module.exports = __webpack_public_path__ + "img/icon-MA-WrapUp.f8794b03.png";